import type { MatchGroup } from '@/api/user-data-management';

/** Build a catalog query from actual source text, never from null placeholders. */
export function reviewSearchQuery(group: Pick<MatchGroup, 'brand' | 'cigar_name'>): string {
  const rawBrand = typeof group.brand === 'string' ? group.brand.trim() : '';
  const rawName = typeof group.cigar_name === 'string' ? group.cigar_name.trim() : '';
  const brand = rawBrand.toLowerCase() === 'null' ? '' : rawBrand;
  const name = rawName.toLowerCase() === 'null' ? '' : rawName;
  const includesBrand = brand && name.toLowerCase().startsWith(`${brand.toLowerCase()} `);
  return (includesBrand ? name : [brand, name].filter(Boolean).join(' '))
    .replace(/\s+/g, ' ').trim().slice(0, 100);
}
